import { EventConstants, Parser } from "@quest/platform-murka-phase_2/dist";
import { PlatformConstantsGame } from "../Constants/PlatformConstantsGame";
import { clone, dispatcher, IEvent, ingenuity } from "@quest/base-core";
import { GameParserModel } from "./GameParserModel";
import { SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { IGetBetResultData, ILines, IParamsData } from "@quest/oddsworks-platform";
import { IWinLineObject, SlotConstants } from "@quest/slot-core";
import { IObject } from "@quest/adapter-interface";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
export class GameParser extends Parser {
  protected specialSymNum: number[] = [110, 150, 151, 152, 153, 77];
  protected udpatedSpecialSymNum: number[] = [11, 15, 12, 13, 14, 7];

  protected bindEvent(): void {
    super.bindEvent();
    dispatcher.on(eventDispatchers.PARSE_NEXT_RESPIN_DATA, this.parseNextHoldAndRespinData, this);
  }
  // Override to update reel set value based on monkey symbol
  protected processReelsData(reelsData: any): void {
    (ingenuity.parserModel as GameParserModel).setReelSets(reelsData);
    (ingenuity.parserModel as GameParserModel).setBaseReel(this.changeSymbolNumber(reelsData[PlatformConstantsGame.BASE_GAME_REELSET]));
    (ingenuity.parserModel as GameParserModel).setFreeSpinReel(this.changeSymbolNumber(reelsData[PlatformConstantsGame.FREE_GAME_REELSET]));
  }
  /**
   * overide to parse game specific features
   * @param response
   */
  protected processBonusInfo(response?: any[]): void {
    super.processBonusInfo(response);
    response.length &&
      response.forEach((data) => {
        if (data.bonusName === ingenuity.configData.SelectReels) {
          this.updateNewBaseReel(data.reelSelected);
        }
        if (data.bonusName === ingenuity.configData.retriggerFreegame) {
          this.processRetriggerData(data);
        }
        if (data.bonusName === ingenuity.configData.collectWild) {
          this.processCollectWild(data);
        }
        if (data.bonusName === ingenuity.configData.stickyWild) {
          this.processStickyWild(data);
        }
        if (data.bonusName === ingenuity.configData.holdAndRespin) {
          this.processHoldAndRespinBonusData(data);
        }
        if (data.bonusName === ingenuity.configData.initialCoinDetails) {
          //before price update
          this.parseCoinInitialDetails(data);
        }
        if (data.bonusName === ingenuity.configData.baseCoinDetails) {
          //after update values
          this.processBonusUpdatedData(data);
        }
        if (data.bonusName === ingenuity.configData.AddNewCoins) {
          this.parseCoinDetails(data);
        }
        if (data.bonusName === ingenuity.configData.HoldAndRespinWins) {
          this.parseJackpotData(data);
        }
      });
  }

  private parseJackpotData(data: any): void {
    const jackpotStatus: boolean = data.grandPrize;
    (ingenuity.parserModel as GameParserModel).setJackpotAvailable(jackpotStatus);
    if (jackpotStatus) {
      const jackpotAmount: number = data.grandPrizewin;
      (ingenuity.parserModel as GameParserModel).setJackpotAmount(jackpotAmount);
      //this.model.setBaseGameWinAmt(this.model.getBaseGameWinAmt() + jackpotAmount);
    }
  }
  protected processGetBetResult(betResultData: IGetBetResultData): void {
    betResultData.balance >= 0 && this.model.setBalance(betResultData.balance); betResultData.freeBalance >= 0 && this.model.setFreeBalance(betResultData.freeBalance);
    this.model.setFreePlaysData(betResultData.freePlaysData);
    betResultData.params && this.processParameters(betResultData.params[0]);
    this.model.setIsPlayingFreePlay(betResultData.playingFreePlay);
    dispatcher.fireEvent(EventConstants.UPDATE_CREDIT_VALUE);
  }


  /**
   * function to store skull symbol position and type
   */
  private parseCoinDetails(data: any): void {
    data.newCoinInfo = this.getSortedDataByOffset(data.newCoinInfo);
    data.coinInfo = this.getSortedDataByOffset(data.coinInfo);
    let bonusCoinsData: { offSet: number[]; position: number; color: string; prize: number; multiplier: string; reward: string; symbolType: number }[] =
      [];
    let bonusWinCoinsData: { offSet: number[]; position: number; color: string; multiplier: string; prize: number; reward: string }[] = [];
    data.newCoinInfo.forEach((coinData: IObject) => {
      let coin: string = coinData.coinType ? coinData.coinType : coinData.coin;
      bonusCoinsData.push({
        offSet: this.convertPositionIntoOffsets([coinData.offSet - 1])[0],
        position: coinData.offSet - 1,
        color: (ingenuity.parserModel as GameParserModel).coinTypeToColor[coin],
        multiplier: coinData.multiplier,
        prize: coinData.prize,
        reward: coinData.reward,
        symbolType: coinData.coinType,
      });
    });
    data.coinInfo.forEach((coinData: IObject) => {
      let coin: string = coinData.coinType ? coinData.coinType : coinData.coin;
      bonusWinCoinsData.push({
        offSet: this.convertPositionIntoOffsets([coinData.offSet - 1])[0],
        position: coinData.offSet - 1,
        color: (ingenuity.parserModel as GameParserModel).coinTypeToColor[coin],
        multiplier: coinData.prize,
        prize: coinData.prize,
        reward: coinData.reward,
      });
    });
    (ingenuity.parserModel as GameParserModel).setBonusWinCoinData(bonusWinCoinsData);
    (ingenuity.parserModel as GameParserModel).setBonusCoinsData(bonusCoinsData);
  }

  private resetHoldAndRespinData(): void {
    (ingenuity.parserModel as GameParserModel).setHoldAndRespinStatus(false);
    (ingenuity.parserModel as GameParserModel).setJackpotAmount(0);
    (ingenuity.parserModel as GameParserModel).setTotalReSpin(0);
    (ingenuity.parserModel as GameParserModel).setJackpotAvailable(false);
    (ingenuity.parserModel as GameParserModel).setHoldAndRespinTotalWin(0);
  }

  protected parseNextHoldAndRespinData(): void {
    const respinData = (ingenuity.parserModel as GameParserModel).getHoldAndRespinSpinData()[
      (ingenuity.parserModel as GameParserModel).getCurrentReSpin()
    ][0];
    this.processBonusInfo(respinData.bonusInfo);
  }

  protected parseBrokenFreeGameData(): void {
    super.parseBrokenFreeGameData();
    this.checForStackSyminReelGridFG();
  }

  protected processBrokenGameData(data: any): void {
    super.processBrokenGameData(data);
    data.SkullsDataInBroken && this.processBrokenLevelData(data.SkullsDataInBroken.brokenElementLevelData);
  }

  private processBrokenLevelData(data: any): void {
    (ingenuity.parserModel as GameParserModel).setBlueElementCount(data.BlueElementCount);
    (ingenuity.parserModel as GameParserModel).setRedElementCount(data.RedElementCount);
    (ingenuity.parserModel as GameParserModel).setGreenElementCount(data.GreenElementCount);
  }

  protected parseNextFreeSpinData(evt?: IEvent): void {
    let data: { bonusName: string; wildPos: any[] } = { bonusName: ingenuity.configData.collectWild, wildPos: [] };
    (ingenuity.parserModel as GameParserModel).setCollectWildData(data);
    super.parseNextFreeSpinData(evt);
  }

  // Find free spin symbols offset
  protected parseFreeSpinSymbolOffsets(): void {
    const reelGrid: number[][] = this.model.getReelGrid();
    const symbolPositionArray: number[][] = [];
    for (let i: number = 0; i < reelGrid.length; i++) {
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        const symbolNumber: number = reelGrid[i][j];
        if (symbolNumber === gameConstants.SYMBOL_SCATTER) {
          symbolPositionArray.push([i, j]);
        }
      }
    }
    (ingenuity.parserModel as GameParserModel).setFSSymboloffsets(this.sortArrayByFirstElement(symbolPositionArray));
  }

  // Override to create scatter data
  protected processTriggerScatterWin(response: any): void {
    if (response.scatterOffset) {
      this.parseFreeSpinSymbolOffsets();
      this.model.getTriggerScatterWinData().length = 0;
      const winScatter: IWinLineObject[] = [
        {
          id: 0,
          no: gameConstants.FREESPIN_SYMBOL_GAME,
          win: response.creditsWon ? response.creditsWon : 0,
          positions: (ingenuity.parserModel as GameParserModel).getFSSymbolOffsets(),
          winSymLen: (ingenuity.parserModel as GameParserModel).getFSSymbolOffsets().length,
        },
      ];

      this.model.setTriggerScatterWinData(winScatter);
      this.model.getTriggerScatterWinData().length > 0 && this.model.setHasScatterWins(true);
    }
  }

  /**
   * to store basegame hold and respin bonus info
   */
  private processHoldAndRespinBonusData(data: any): void {
    this.model.setTotalWin(this.model.getTotalWin() - data.creditsWon);
    this.model.setCurrentWin(this.model.getCurrentWin() - data.creditsWon);
    (ingenuity.parserModel as GameParserModel).setHoldAndRespinTotalWin(data.creditsWon);
    (ingenuity.parserModel as GameParserModel).setHoldAndRespinStatus(true);
    (ingenuity.parserModel as GameParserModel).setHoldAndRespinType(data.bonusTrigger);
    (ingenuity.parserModel as GameParserModel).setHoldAndRespinSpinData(data.freeSpinList);
    (ingenuity.parserModel as GameParserModel).setTotalReSpin(data.freeSpinList.length);
  }

  /**
   * function to store all bonus symbol offset
   */
  private processBonusUpdatedData(data: any): void {
    data.coinInfo = this.getSortedDataByOffset(data.coinInfo)
    let bonusCoinsData: { offSet: number[]; position: number; color: string; multiplier: string; prize: number; symbolType: number }[] = [];
    data.coinInfo.forEach((coinData: IObject) => {
      let coin: string = coinData.coinType ? coinData.coinType : coinData.coin;
      bonusCoinsData.push({
        offSet: this.convertPositionIntoOffsets([coinData.offSet - 1])[0],
        position: coinData.offSet - 1,
        color: (ingenuity.parserModel as GameParserModel).coinTypeToColor[coin],
        multiplier: coinData.multiplier,
        prize: coinData.prize,
        symbolType: coinData.coinType,
      });
    });
    (ingenuity.parserModel as GameParserModel).setUpdatedBonusCoinsData(bonusCoinsData);
  }

  /**
   * sort data by position
   * @param data 
   * @returns 
   */
  private getSortedDataByOffset(data: any): any {
    data.sort((a: any, b: any) => a.offSet - b.offSet);
    return data;
  }

  /**
   * function to store coins position and type
   */
  private parseCoinInitialDetails(data: any): void {
    data.baseCoinDetails = this.getSortedDataByOffset(data.baseCoinDetails)
    let bonusCoinsData: { offSet: number[]; position: number; color: string; multiplier: string; prize: number }[] = [];
    let bonusSymbolOffsets: {
      offSet: number[];
      pos: number;
      color: string;
      symbolType: number;
      prize: number;
      multiplier: number;
      reward: any;
    }[] = [];
    data.baseCoinDetails.forEach((coinData: IObject) => {
      let coin: string = coinData.coinType ? coinData.coinType : coinData.coin;
      if (coinData.coinType != gameConstants.SKULL_GOLDEN) {
        bonusSymbolOffsets.push({
          offSet: this.convertPositionIntoOffsets([coinData.offSet - 1])[0],
          color: (ingenuity.parserModel as GameParserModel).coinTypeToColor[coin],
          pos: coinData.offSet - 1,
          symbolType: coinData.coinType,
          prize: coinData.prize,
          multiplier: coinData.multiplier,
          reward: coinData.reward,
        });
      }
      bonusCoinsData.push({
        offSet: this.convertPositionIntoOffsets([coinData.offSet - 1])[0],
        position: coinData.offSet - 1,
        color: (ingenuity.parserModel as GameParserModel).coinTypeToColor[coin],
        multiplier: coinData.multiplier,
        prize: coinData.prize,
      });
    });
    // bonusCoinsData= this.getSortedDataByOffset(bonusCoinsData);
    // bonusSymbolOffsets = this.getSortedDataByOffset(bonusSymbolOffsets);
    (ingenuity.parserModel as GameParserModel).setBonusTriggeringOffset(bonusSymbolOffsets);
    (ingenuity.parserModel as GameParserModel).setBonusCoinsInitialData(bonusCoinsData);
  }

  /**
   * This method will change the offsets from [row] to [row, col] type
   */
  private convertPositionIntoOffsets(grid: number[]): number[][] {
    const offsets: number[][] = [];
    for (let i = 0; i < grid.length; i++) {
      const symOnGrid: number = grid[i];
      const row: number = Math.floor(symOnGrid / (ingenuity.parserModel as GameParserModel).getNumCols());
      const col: number = symOnGrid % (ingenuity.parserModel as GameParserModel).getNumCols();
      offsets.push([col, row]);
    }
    return offsets;
  }

  private processStickyWild(data: any): void {
    //to remove duplicate entries
    data.wildPos = data.wildPos.filter((item: number, index: number) => data.wildPos.indexOf(item) === index);
    (ingenuity.parserModel as GameParserModel).setStickyWildDataRawData(data.wildPos);
    data.wildPos = this.getGridToOffset(data.wildPos);
    if (ingenuity.configData.isBrokenGame) {
      (ingenuity.parserModel as GameParserModel).setCollectWildData(data);
    }
    (ingenuity.parserModel as GameParserModel).setStickyWildData(data);
  }

  protected parseFreeSpin(response: any): void {
    this.model.setCurrentWin(this.model.getCurrentWin() - response.creditsWon);
    this.processTriggerScatterWin(response);
    super.parseFreeSpin(response);
  }

  private processCollectWild(data: any): void {
    let posData: any = []
    let sticky = (ingenuity.parserModel as GameParserModel).getStickyWildDataRawData();
    if (sticky?.length) {
      data.wildPos.forEach((element: number) => {
        if (!sticky.includes(element)) {
          posData.push(element);
        }
      });
      data.wildPos = [...posData];
    }
    data.wildPos = this.getGridToOffset(data.wildPos);
    (ingenuity.parserModel as GameParserModel).setCollectWildData(data);
  }

  /**
   * overide to store jackpot multipler values
   * @param params
   */
  protected processGameParameters(params: any): void {
    super.processGameParameters(params);
    (ingenuity.parserModel as GameParserModel).setJackpotData(params.jakcpotPays);
  }

  protected processParameters(params: IParamsData): void {
    this.resetHoldAndRespinData();
    super.processParameters(params);
  }

  //update new reel set
  private updateNewBaseReel(reelSetName: string): void {
    let reels: number[][] = clone((ingenuity.parserModel as GameParserModel).getReelSets(reelSetName));

    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      (ingenuity.parserModel as GameParserModel).setFreeSpinReel(this.changeSymbolNumber(reels));
    }
    (ingenuity.parserModel as GameParserModel).setBaseReel(this.changeSymbolNumber(reels));
    dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_REEL_SET);
  }

  // Overrided to check if wild win available
  protected processLinesData(data: ILines[]): void {
    super.processLinesData(data);
    this.checkForWildWin();
  }

  // To check wild win available
  private checkForWildWin(): void {
    this.model.getWinLinesData().forEach((data: any) => {
      if (data.no === gameConstants.SYMBOL_WILD) {
        (ingenuity.parserModel as GameParserModel).setIsWildWin(true);
      }
    }, this);
  }
}
